
export const transactionurl = {
    bsc: 'https://testnet.bscscan.com//tx/',
} 


